import { createContext, useState } from 'react';
import './App.scss';
import "react-toastify/ReactToastify.min.css";
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import OnboardingLayout from './components/layout/onboarding-layout/OnboardingLayout';
import Login from './components/onboarding/Login';
import ForgetPassword from './components/onboarding/ForgetPassword';
import OTP from './components/onboarding/OTP';
import ResetPassword from './components/onboarding/ResetPassword';
import DashboardLayout from './components/layout/dashboard-layout/DashboardLayout';
import Blogs from './pages/Blogs/Blogs';
import Category from './pages/category/Category';
import AddCategory from './pages/category/AddCategory';
import AddBlog from './pages/Blogs/AddBlog';
import BlogDetail from './pages/Blogs/BlogDetail';
import { ToastContainer } from 'react-toastify';
import Spinner from './components/Common/Spinner'; 
import EditBlog from './pages/Blogs/EditBlog';
import EditCategory from './pages/category/EditCategory';
import { AuthProvider } from './auth/AuthProvider';

const router = createBrowserRouter([
  {
    path: "/",
    element: <OnboardingLayout />,
    children: [
      {
        path: "",
        element: <Login />,
      },
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "forgetPassword",
        element: <ForgetPassword />,
      },
      {
        path: "otp",
        element: <OTP />,
      },
      {
        path: "resetPassword",
        element: <ResetPassword />,
      },
    ],
  },
  {
    path: "/",
    element: <DashboardLayout />,
    children: [ 
      {
        path: "category",
        element: <Category />,
      },
      {
        path: "/category/addCategory",
        element: <AddCategory />,
      },
      {
        path: "/category/editCategory/:id",
        element: <EditCategory />,
      },
      {
        path: "/blog",
        element: <Blogs />,
      },
      {
        path: "/blog/addBlog",
        element: <AddBlog />,
      },
      {
        path: "/blog/editBlog/:id",
        element: <EditBlog />,
      },
      {
        path: "/blog/blog-detail/:titleSlug",
        element: <BlogDetail />,
      },
    ],
  },
]);

//  context code ==========
export const GlobalContext = createContext(null);
function App() {
  const [spinner, setSpinner] = useState(false);
  const [toggleBtn, settoggleBtn] = useState(false);
  const [adminName, setAdminName] = useState("");
  let [showUserImage, setShowUserImage] = useState("");

  return (
    <>
      {spinner && <Spinner />}
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <AuthProvider>
      <GlobalContext.Provider
        value={{
          setSpinner,
          settoggleBtn,
          setAdminName,
          adminName,
          toggleBtn,
          showUserImage,
          setShowUserImage,
        }}
      >
        <RouterProvider router={router} />
      </GlobalContext.Provider>
      </AuthProvider>
      
    </>
  );
}

export default App;
